import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
// import Image from "../components/image"
import SEO from "../components/seo"
import Card from "../components/Card"
import Section from "../components/Section"
import SectionAbout from "../components/SectionAbout"
import Wave from "../components/Wave"
import staticdata from '../../staticdata.json'
import Cell from '../components/Cell'
import styled from 'styled-components'

const SectionCaption = styled.p`
font-weight: 600;
font-size: 18px;
text-transform: uppercase;
color: #94A4BA!important;
text-align: center;
`
const SectionCellGroup = styled.div`
max-width: 800px;
margin: 0 auto 100px;
display: grid;
grid-template-columns: repeat(2, 1fr);
grid-column-gap: 20px;
padding: 0 20px;

@media (max-widht: 640px) {
  display: inline-block!important;
}
`

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <div className="Hero">
      <div className="HeroGroup">
        <h1>Find a course<br />
        that speaks to&nbsp;You</h1>
        <p>Linglab helps you speak a language better and faster by using adaptive learning algorithm, structured content and other linguistics techniques.</p>
        <Link to="/#Cards">Learn More</Link>
        <div className="Logos">
          <img src={require('../images/flag-uk-01.png')} width="50" />
          <img src={require('../images/flag-it-01.png')} width="50" />
          <img src={require('../images/flag-fr-01.png')} width="50" />
          <img src={require('../images/flag-ru-01.png')} width="50" />
          <img src={require('../images/flag-de-01.png')} width="50" />
          <img src={require('../images/flag-ua-01.png')} width="50" />
        </div>
        <Wave />
      </div>
    </div>
    <div id="Cards">
      <h2>6 courses, more coming</h2>

      <div className="CardGroup">

        {/* To use autofill after <Card --> to auto _import Card from "../components/Card"_ */}

        <Card
          title="Russian for Children"
          text="10 sections"
          image={require('../images/card-children.jpg')}
        />
        <Card
          title="Second Language Acquisition"
          text="12 sections"
          image={require('../images/card-lang-04.jpg')}
        />
        <Card
          title="Business Russian"
          text="12 sections"
          image={require('../images/card-business.png')}
        />
        <Card
          title="Russian for the Fashion Industry"
          text="10 sections"
          image={require('../images/card-fashion-03-a.png')}
        />
        <Card
          title="Russian Cinematography"
          text="8 sections"
          image={require('../images/card-cinema.png')}
        />
        <Card
          title="Assistance in Academic Research"
          text="12 sections"
          image={require('../images/card-university.png')}
        />
      </div>
    </div>
    <Section
      image={require('../images/hero-img-02.png')}
      logo={require('../images/logo-ru.png')}
      title="Russian Courses" />

    <div>
      <SectionCaption>6 sections - 18 hours</SectionCaption>
      <SectionCellGroup className="SectionCellGroupMb">
        {staticdata.cells.map(cell => (
          /* <div>{cell.title}</div> */

          < Cell
            title={cell.title}
            image={cell.image} />

        ))}
      </SectionCellGroup>
    </div>
    <div id="ProficiencyTest"></div>
    <SectionAbout
      image={require('../images/russian-test-01.png')}
      logo={require('../images/logo-courses.png')}
      title="Russian proficiency test"
    // text="Preparing for examination, Linglab provides students with the materials corresponding to the required certification level and the multiple tests to provide a set of measures of functional proficiency in Russian language and assists in explaining difficulties or reinforcing language skills.
    // The reading comprehension section consists of short texts followed by several questions translated into English and some writing tasks, all of which are aimed to assist in memorizing the language pattern and grammatical units.
    // To improve listening skills, Linglab uses materials based on authentic speech samples, and through speaking, encourages the students to interpret their communication style into the foreigner language."

    />

    <div id="Contact">
      <h2 id="Contact">Contact us</h2>

      <form className="ContactForm"
        // Avoid calling only "form" or Netlify doesn't display fields
        name="contact-form"
        value="contact-form"
        method="post"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        onSubmit="submit"
      >

        <input type="hidden" name="contact-form" value="contact-form" />

        <span>Hello,</span>
        <label for="name">My name is
      <input name="name" placeholder="type in your name here" type="text" /></label>
        <label for="email">Here is my email address
      <input name="email" placeholder="type in your email address here" type="email" /></label>
        <label for="message">I would like
      <textarea name="message" placeholder="to find out more about" />
          {/* <textarea name="message" placeholder="to receive more info about..." /> */}
        </label>
        <div className="ContactButtonWrapper"><button type="submit">Send</button></div>
      </form>

    </div>

  </Layout >
)

export default IndexPage
